<template>

  <div :class="{'opacity-50 cursor-not-allowed pointer-event': inProgress || (ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || !isLeader }">
    <h1 class="text-bold text-blue mb-5">
      <div v-if="formName == 'STRUCTURE_AND_ORGANIZATION'">{{ $t("ecosystem.structure_and_organization") }}</div>
      <div v-if="formName == 'ANTERIOR_PROGRAMS'">{{ $t("ecosystem.anterior_programs") }}</div>
      <div v-if="formName == 'DEAL_FORM'">{{ $t("ecosystem.deal") }}</div>
      <div v-if="formName == 'SAIL_FORM'">{{ $t("ecosystem.sail") }}</div>
      <div v-if="['GENERAL_INFOS_AIR', 'GENERAL_INFOS_AIR2'].includes(formName)">{{ $t("ecosystem.general_infos") }}</div>
      <div v-if="formName == 'AIR'">{{ $t("ecosystem.air") }}</div>
      <div v-if="formName == 'AIR2'">{{ $t("ecosystem.air2") }}</div>
    </h1>
    <div v-if="isSubmitted && errors == null"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
      >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.submitted") }}</strong>
      </p>
    </div>
    <div v-if="errors || (formData && formData.started && !formData.complited)" class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.infinsh") }}</strong>
      </p>
    </div>
    <form v-if="formData" autocomplete="off" name="ecosystem-generic-form" @click="handleClick($event)" @submit.prevent="saveForm($event)">
      <div v-for="(q, index) in formData.questions" :key="'A'+index">
        <div v-if="q.category_id === null">
          <div v-if="(formData.code_name == 'INVESTOR_GUARANTEE_FORM')">
          <q-form
            :question="q"
            :responses="responses"
            :formType="formData.code_name"
            @response-updated="handleResponseUpdate"
            @response-updated-labelRef="handleResponseUpdate2"
            :child-identifiant="dataIdentif"
            :child-legal-name="dataLegalName"
            :started="formData.started"
            :showError="showError"
            @governorate="governoratechange"
            :delegation="delegation"
            :disabled="(ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || !isLeader"
          ></q-form>
          </div>
          <div v-else>
          <q-form
            :question="q"
            :responses="responses"
            :started="formData.started"
            :showError="showError"
            @governorate="governoratechange"
            :delegation="delegation"
            :disabled="(ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || !isLeader"
          ></q-form>
          </div>
        </div>
      </div>
      <div v-for="(cat,index) in formData.categories" :key="'D'+index">
        <h2
          class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b"
        >{{cat.name}}</h2>
        <div v-for="(q, index) in formData.questions" :key="'B'+index">
          <div v-if="q.category_id === cat.id">
            <q-form
              :question="q"
              :responses="responses"
              :started="formData.started"
              :showError="showError"
              @governorate="governoratechange"
              :delegation="delegation"
              :disabled="(ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || !isLeader"
            ></q-form>
          </div>
        </div>
      </div>

      <div v-if="currentUser.role != 'form-builder'" class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
        >
        <sp-button
          theme="outline-blue"
          space="small"
          type="submit"
          name="draft"
          :disabled="(ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || inProgress || !isLeader"
        >{{ $t("form.saveDraft")}}</sp-button>
        <sp-button
          theme="blue"
          space="small"
          type="submit"
          name="next"
          :disabled="(ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11') || inProgress || !isLeader"
        >{{ $t("form.next")}}</sp-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import QForm from "@/components/Candidat/QForm.vue";
import Button from "@/components/spKit/Button.vue";
import { mapGetters, mapState } from "vuex";
import {
  GET_ECOSYSTEM_FORM_DATA,
  SAVE_ECOSYSTEM_FORM,
  FETCH_ECOSYSTEM_APPLICATION,
  GET_BUILDER_FORM_DATA
} from "@/store/actions.type";
import { SET_ECOSYSTEM_MENU_ACTIVE, SET_PROGRESS } from "@/store/mutations.type";
export default {
  name: 'EcosystemForm',
  data() {
    return {
      ecoAppId: null,
      appType: null,
      formName: null,
      inProgress: false,
      responses: [],
      isSubmitted: false,
      showError: false,
      formData: null,
      target: 'draft',
      isLeader: true,
      delegation:null,
      dataIdentif: '',
      dataLegalName: ''
    };
  },
  components: {
    "q-form": QForm,
    "fragment": Fragment,
    "sp-button": Button
  },
  mounted(){
    this.$Progress.start();
    if (this.currentUser.role != 'form-builder') {
      this.ecoAppId = this.$route.params.ecoAppId;
      this.appType = this.$route.params.appType;
      this.formName = this.upperlace(this.$route.params.formName);
      this.$store
        .dispatch(FETCH_ECOSYSTEM_APPLICATION, this.ecoAppId);
      this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
      this.getFormData();
    } else {
      this.$store
        .dispatch(GET_BUILDER_FORM_DATA, this.$route.params.id)
        .then(data => {
          this.formData = data.data.form
        });
    }
    this.$Progress.finish();
  },
  methods: {
    governoratechange(data){
      this.delegation=data;
    },
    handleClick(event) {
      this.target = event.target.name
    },
    saveForm(event) {
      this.inProgress = true;
      let form = this.getForm();
      this.isSubmitted = false;
      // Check form is empty or not
      var isEmptyForm = true;
      this.responses.forEach(answer => {
        if (answer.content != "") {
          return isEmptyForm = false;
        }
      });
      this.$store.dispatch(SAVE_ECOSYSTEM_FORM, {
        form: form,
        formName: this.formName
      }).then((response) => {
        this.$store.commit(SET_PROGRESS, response.data.progress);
        window.scrollTo(0, 0);
        // Show form.submitted text when form is not empty 
        if (!isEmptyForm) {
          this.isSubmitted = true;
        }
        this.inProgress = false;
        this.responses = [];
        this.showError = true;
        if (this.target == 'next') {
          if (this.formName == "STRUCTURE_AND_ORGANIZATION") {
            this.$router.push({
              name: "AnteriorPrograms",
              params: {
                formName: 'anterior-programs',
                ecoAppId: this.ecoAppId,
                appType: this.appType.toLowerCase()
              }
            });
          } else if (this.formName == "GENERAL_INFOS_AIR") {
            this.$router.push({
              name: "Air",
              params: {
                formName: 'air',
                ecoAppId: this.ecoAppId,
                appType: this.appType.toLowerCase()
              }
            });
          } else if (this.formName == "GENERAL_INFOS_AIR2") {
            this.$router.push({
              name: "Air2",
              params: {
                formName: 'air2',
                ecoAppId: this.ecoAppId,
                appType: this.appType.toLowerCase()
              }
            });
          } 
          else if (this.formName == "GENERAL_INFOS_D4D") {
            this.$router.push({
              name: "FundingRequirements",
              params: {
                formName: 'funding-requirements',
                ecoAppId: this.ecoAppId,
                appType: this.appType.toLowerCase()
              }
            });
          } else if (["ANTERIOR_PROGRAMS", "AIR", "AIR2", "FUNDING_REQUIREMENTS"].includes(this.formName)) {
            this.$router.push({
              name: "EcoTeam",
              params: {
                app_id: this.ecoAppId
              }
            });
          } else {
            this.$router.push({
              name: "FormChecklist",
              params: {
                app_id: this.ecoAppId
              }
            });
          }
        } else if (this.target == 'draft') {
          this.getFormData();
        }
      });
      this.inProgress = false;
    },
    getForm() {
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (Array.isArray(final.content) && final.content.length === 0)
          final.content = "";
        if (final.content != null) {
          finalResponses.push(final);
        }
      });
      let form = {
        id: this.$route.params.ecoAppId,
        responses: finalResponses
      };
      return form;
    },
    upperlace(string) {
      let result = string.replace(/-/g, "_");
      result = result.toUpperCase();

      return result;
    },

    getFormData() {
      this.$store
        .dispatch(GET_ECOSYSTEM_FORM_DATA, {
          type: this.appType,
          formName: this.formName,
          hashId: this.ecoAppId
        })
        .then(data => {
          this.$store.commit(SET_PROGRESS, data.data.data.progress);
          if (this.ecosystemApp.application.user_id != this.currentUser.id) {
            this.isLeader = false;
          }
          this.showError = true;
        })
        .catch(error => {
          this.$router.push({ name: "home" });
        });
    },
    handleResponseUpdate(response) {
      this.dataIdentif = response;
    },
    handleResponseUpdate2(response) {
      this.dataLegalName = response;
    },
  },
  computed: {
    ...mapGetters([
      "ecosystemApp",
      "form",
      "currentUser"
    ]),
    ...mapState({
      errors: state => state.ecosystem.errors
    })
  },
  watch: {
    errors() {
      this.$Progress.fail();
    },
    form() {
      this.formData = this.form;
    }
  },
  beforeDestroy() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
  }
}
</script>

<style>
.pointer-event {
  pointer-events: none
}
</style>
